import PriorityBadge from "../../components/Layout/PriorityBadge";

import { useLocation } from "react-router-dom";
import { CHECKOUT_PAYMENT, HOME, SEND_FOLIO } from "../../routes/Paths";
import { CONFIG_MASTER_ENUM, STEP_MASTER_ENUM } from "../../constants/constant";
import { timerConstantValue } from "../../constants/timers";
import { checkOut, fetchFolio, saveFolio } from "../../network/apiService";
import { GetauthorizationHistory } from "../../network/apiService";
import { fetchStep, postAuditLog, getIsSkipped } from "../../store/stageSlice";
// import { checkOut, fetchFolio, saveFolio } from "../../network/apiService";
// import { postAuditLog } from "../../store/stageSlice";
import {
  fetchModulesConfiguration,
  getModuleConfiguration,
} from "../../store/Checkin/moduleConfigurationSlice";
import {
  getConfigurationCode,
  getConfigurationCodeMandatory,
  getModuleStatus,
  getParametersFromLocalStorage,
  getStepMaster,
} from "../../helpers/commonHelper";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import AgreedForm from "../../components/TermsAndConditions/AgreedForm";
import CheckoutFooter from "../../components/Layout/CheckoutFooter";
import ErrorPopup from "../../components/LoaderAndNotification/ErrorPopup";
import HomePageCard from "../../components/Layout/Card/HomePageCard";
import LoaderPopup from "../../components/LoaderAndNotification/LoaderPopup";
import SuccessPopup from "../../components/LoaderAndNotification/SuccessPopup";
import { getCheckoutData } from "../../store/Checkout/checkoutSlice";
import { getPropertyInfo } from "../../store/Checkin/Scan/propertySlice";
import { homePageHandler } from "../../helpers/commonHelper";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import useUserActivity from "../../hooks/useUserActivity";
import { getUserConsentMaster } from "../../network/apiService";

const InvoiceInformation = () => {
  const [isPreauth, setIsPreauth] = useState(null);
  //User consent
  const [userConsents, setUserConsents] = useState([]);

  const [checkbox1, setCheckoutConsent1] = useState(false);
  const [checkbox2, setCheckoutConsent2] = useState(false);
  const [checkbox3, setCheckoutConsent3] = useState(false);

  const handleCheckboxChange1 = (e) => {
    setCheckoutConsent1(e.target.checked);
  };
  const handleCheckboxChange2 = (e) => {
    setCheckoutConsent2(e.target.checked);
  };
  const handleCheckboxChange3 = (e) => {
    setCheckoutConsent3(e.target.checked);
  };

  const location = useLocation();
  const reservationData = location.state?.reservationData;

  const timeLimit = timerConstantValue;
  const [showModal, setShowModal] = useState(false);
  const [timerValue, setTimerValue] = useState(timeLimit);
  const [restartTimer, setRestartTimer] = useState(false);
  const navigate = useNavigate();
  const data = useSelector(getCheckoutData);
  const [loading, setLoading] = useState(false);
  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const [errorModal, setErrorModal] = useState(null);

  const [folio, setFolio] = useState();
  const [folioReceived, setfolioReceived] = useState(false);
  const propertyData = useSelector(getPropertyInfo);
  const [signature, setSignature] = useState(null);
  const [url, setUrl] = useState(null);
  const token = getParametersFromLocalStorage("token");
  const confirmationNo = localStorage.getItem("confirmationNo");
  const reservationNameID = localStorage.getItem("reservationNameID");
  const [totalAmount, setTotalAmount] = useState(0);

  const [totalDue, setTotalDue] = useState(null);
  const userData = useSelector(getCheckoutData);
  const [successLoader, setSuccessLoader] = useState(false);

  const stepMaster = useSelector((state) => getModuleConfiguration(state));

  const stepFolioPage = getStepMaster(stepMaster, STEP_MASTER_ENUM.FOLIO_PAGE);
  const configs = stepFolioPage?.configs;
  const paymentPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.CHECKOUT_PAYMENT_PAGE
  );
  const isSettleByPMS = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.SETTLE_BY_PMS
  );

  const showFolioPage = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.FOLIO_VIEW
  );
  const signatureFolioRequired = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.SIGNATURE_FOLIO_REQUIRED
  );
  const signatureFolioManadatory = getConfigurationCodeMandatory(
    configs,
    CONFIG_MASTER_ENUM.SIGNATURE_FOLIO_REQUIRED
  );

  const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);

  const showReservationPage = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.RESERVATION_INFO
  );
  const fetchPreauthStatus = async () => {
    try {
      const ResNameID = localStorage.getItem("reservationNameID");
      const response = await GetauthorizationHistory(
        { ReservationNameID: ResNameID },
        token
      );
      const result = response?.data?.result;
      setIsPreauth(result === true || result === "true");
      return result === true || result === "true";
    } catch (err) {
      console.error("Error fetching preauth status", err);
      setIsPreauth(false);
      return false;
    }
  };

  const dispatch = useDispatch();
  const [showFolio, setshowFolio] = useState(showFolioPage != null);
  const [signatureRequired, showSignatureRequire] = useState(
    signatureFolioRequired
  );

  const resetTimerAndClosePopUp = () => {
    if (!timerValue) {
      setTimerValue(timeLimit);
    }
    setRestartTimer(true);
    setShowModal(false);
  };

  const timerCounter = (value) => {
    setTimerValue(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const stopTimer = () => {
    setRestartTimer(false);
  };

  const navigateToPayment = () => {
    ;
    setTotalAmount(localStorage.getItem("balanceAmount"));
    if (totalAmount <= 0 || paymentPage === undefined || paymentPage === null) {
      navigate(SEND_FOLIO, { replace: true });
    } else {
      navigate(CHECKOUT_PAYMENT, { replace: true });
    }
  };

  // List to keep track of unchecked mandatory consents
  const uncheckedMandatoryConsents = userConsents
    .filter((consent) => consent.isMandatory) // only mandatory consents
    .filter((consent) => {
      const code = consent.consentCode;
      if (code === "CheckoutConsent1") return !checkbox1;
      if (code === "CheckoutConsent2") return !checkbox2;
      if (code === "CheckoutConsent3") return !checkbox3;

      // add other consents here if any
      return false; // default: considered checked
    });
  // Define fetchConsents to get user consents from API
  const fetchConsents = async () => {
    try {
      const response = await getUserConsentMaster(token);
      if (response.status === 200) {
        const data = response?.data?.data || response?.data || [];
        setUserConsents(data.filter((consent) => consent.isActive));
      }
    } catch (error) {
      console.error("Failed to fetch consents", error);
    }
  };

  // Call fetchConsents once when component mounts
  useEffect(() => {
    fetchConsents();
  }, []);

  const saveFolioCard = async () => {
    setLoading(true);
    try {
      if (uncheckedMandatoryConsents.length > 0) {
        console.log(
          "Unchecked Mandatory Consents: ",
          uncheckedMandatoryConsents
        );

        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t(
            "Please provide all mandatory consents to proceed with checkout"
          ),
        }));
        setLoading(false);
        return;
      }

      const consents = [];

      if (checkbox1) consents.push("CheckoutConsent1");
      if (checkbox2) consents.push("CheckoutConsent2");
      if (checkbox3) consents.push("CheckoutConsent3");

      const RegCard = {
        reservationID: 0,
        confirmationNo: confirmationNo,
        reservationNameID: reservationNameID,
        signatureBase64: url ?? "-",
        propertyCode: propertyData.propertyCode,
        documentType: "FOLIO",
        consents: [
          {
            consentCode: "CheckoutConsent1",
            consentValue: checkbox1 ? "true" : "false",
          },
          {
            consentCode: "CheckoutConsent2",
            consentValue: checkbox2 ? "true" : "false",
          },
        ],
      };
      ;
      const response = await saveFolio(RegCard, token);
      if (response.data.result && response.status === 200) {
        setLoading(false);
        if (
          totalDue <= 0 ||
          paymentPage === undefined ||
          paymentPage === null
        ) {
          doCheckout(confirmationNo, reservationNameID);
        } else {
          navigate(CHECKOUT_PAYMENT, { replace: true });
        }
        return;
      } else {
        setLoading(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t(
            "Unable to save folio at the moment.Please contact front desk"
          ),
        }));
        setErrorModal(true);

        return;
      }
    } catch (Exception) {
      setLoading(false);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "Unable to save folio at the moment.Please contact front desk"
        ),
      }));
    }
  };
  const doCheckout = async (confirmationNo, reservationNameID) => {
    setLoading(true);

    const RegCard = {
      reservationID: 0,
      confirmationNo: confirmationNo,
      reservationNameID: reservationNameID,
      signatureBase64: null, //use saved signature in DB
      documentType: "FOLIO",
    };
    ;
    var folioSaved = saveFolio(RegCard, token);

    const checkinData = {
      confirmationNo: confirmationNo,
      reservationNameID: reservationNameID,
    };
    const response2 = await checkOut(checkinData, token);
    if (response2?.data?.result === true) {
      setLoading(false);
      setSuccessLoader(true);
      setTimeout(async () => {
        navigate(SEND_FOLIO, { replace: true });
        return;
      }, 2000);
      return;
    } else {
      setLoading(false);

      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "Check-out Not Allowed. Please visit front desk for assistance"
        ),
      }));

      setTimeout(() => {
        handlebackPage();
      }, 6000);

      return;
    }
  };

  //KC-447 Timer need to restart when user interaction is involved
  useUserActivity(() => {
    setTimerValue(timeLimit);
  });
  useEffect(() => {
    if (!folioReceived) {
      fetchFolioData();
    }
  }, [folioReceived]);

  // useEffect(() => {
  //   fetchPreauthStatus(); // fetch preauth once
  // }, []);

  const gotSignature = () => {
    setUrl(signature.getTrimmedCanvas().toDataURL("image/png"));
  };

  const clearSign = () => {
    signature.clear();
    setUrl(null);
  };

  const fetchFolioData = async () => {
    setLoading(true);
    try {
      let totalAmount = 0;
      const folioData = await fetchFolio(
        {
          confirmationNo: confirmationNo,
          reservationNameID: reservationNameID,
        },
        token
      );
      if (
        folioData.data.data !== null &&
        folioData.data.result &&
        folioData.data.data !== ""
      ) {
        let base64File = folioData.data.data.base64File;

        // if (!base64File.startsWith("data:application/pdf;base64,")) {
        //   base64File = `data:application/pdf;base64,${base64File}`;
        // }

        setFolio(base64File);

        totalAmount = parseFloat(folioData.data?.data?.balanceAmount ?? 0);
        //totalAmount = amount?.toFixed(2) > 0 ? amount?.toFixed(2) : 0;
        localStorage.setItem("DueAmount", totalAmount);

        if (totalAmount > 0) {
          setTotalDue(totalAmount);
        } else {
          setTotalDue(0);
        }
        setLoading(false);

        

        const shouldSkipPreauthCheck =
          totalAmount <= 0 || paymentPage === undefined || paymentPage === null;

        if (!shouldSkipPreauthCheck) {
          const isPreauthResult = await fetchPreauthStatus();
          const isPMS = isSettleByPMS === true || isSettleByPMS === "true";
          const isPreauthAllowed =
            isPreauthResult === true || isPreauthResult === "true";
          if (isPMS && !isPreauthAllowed) {
            addLog(
              JSON.stringify(folioData),
              " isPreauth: " +
                isPreauthAllowed +
                "  isSettleByPMS: " +
                isPMS +
                "  totalAmount: " +
                totalAmount,
              "Unable to authorize payment. Please contact the front desk for assistance."
            );
            let blockpaymentatFolio = true;
            localStorage.setItem("blockpaymentatFolio", blockpaymentatFolio);
            setLoading(false);
            setErrorModalData((state) => ({
              ...state,
              toggleError: true,
              errorMessage: t(
                "Unable to authorize payment. Please contact the front desk for assistance."
              ),
            }));
          }
        }
        setfolioReceived(true);
      } else {
        setLoading(false);
        setfolioReceived(true);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t(
            "Unable to generate folio at the moment.Please contact front desk"
          ),
        }));
        setTimeout(() => {
          handlebackPage();
        }, 6000);
      }
    } catch (error) {
      setLoading(false);
      setfolioReceived(true);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "Unable to generate folio at the moment.Please contact front desk"
        ),
      }));

      setTimeout(() => {
        handlebackPage();
      }, 6000);
      // navigate("/home-page");
    }
  };

  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));

    var returnHome = localStorage.getItem("blockpaymentatFolio");
    if (returnHome === "true") {
      handlebackPage();
      localStorage.removeItem("blockpaymentatFolio");
    }
  };

  const handlebackPage = () => {
    try {
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error when redirecting to home page.", error);
    }
  };

  //adding addLog functionality
  const addLog = (response, request, message) => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const data = {
      ActionName: "Invoice Information",
      Message: message,
      ControllerName: "kiosk",
      Request: request ?? "",
      PMSConfirmationNo: confirmationNo,
      AppType: "kiosk",
      Response: response ?? "",

      PropertyCode: propertyData?.data?.propertyCode,
    };
    dispatch(postAuditLog({ data, token }));
  };

  return (
    <div>
      <div
        style={{
          position: "absolute",
          top: "40px",
          right: "20px",
          zIndex: 10,
        }}
      >
        <PriorityBadge reservationData={reservationData} />
      </div>
      <SuccessPopup
        loading={successLoader}
        successMessage={t("You have been successfully Checked-out")}
      />
      <LoaderPopup loading={loading} />
      {!folioReceived ? (
        <></>
      ) : (
        <AgreedForm
          // loading={loading}
          openModal={openModal}
          // closeErrorModal={closeErrorModal}
          // erroModalData={erroModalData}
          navigateToPayment={navigateToPayment}
          savefolioCard={saveFolioCard}
          folio={folio}
          clearSign={clearSign}
          data={data[0]}
          setSignature={setSignature}
          setUrl={setUrl}
          signature={signature}
          gotSignature={gotSignature}
          showFolio={showFolio}
          url={url}
          signatureRequired={signatureRequired}
          onBackPress={handlebackPage}
          showReservationPage={showReservationPage}
          signatureFolioManadatory={signatureFolioManadatory}
          handleCheckboxChange1={handleCheckboxChange1}
          handleCheckboxChange2={handleCheckboxChange2}
          handleCheckboxChange3={handleCheckboxChange3}
          userConsents={userConsents}
          fixedSignatureCanvasHeight={ zoomLevel >= 150 ? 200 : zoomLevel >= 120 ? 200 : zoomLevel >= 100 ? 150 : 150 }
          fixedSignatureCanvasWidth={ zoomLevel >= 150 ? 475 : zoomLevel >= 120 ? 570 : zoomLevel >= 100 ? 650 : 650 }
        ></AgreedForm>
      )}
      <CheckoutFooter
        page={"agreedform"}
        showModal={showModal}
        openModal={openModal}
        timerCounter={timerCounter}
        timerValue={timerValue}
        restartTimer={restartTimer}
        stopTimer={stopTimer}
        timeLimit={timeLimit}
      />
      <ErrorPopup
        closeErrorModal={closeErrorModal}
        erroModalData={erroModalData}
      />

      {showModal && (
        <HomePageCard
          showModal={showModal}
          resetTimerAndClosePopUp={resetTimerAndClosePopUp}
        />
      )}
    </div>
  );
};

export default InvoiceInformation;
